/*
 * Copyright (c) 2022. Haodong JU
 */

import GlobalSettings from '@/GlobalSettings'

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start',
    },
    form: false,
    header: false,
  },
  name: {},
  printTitle: {},
  required: {
    type: IKDataEntity.Types.Boolean,
  },
  multiSelect: {
    type: IKDataEntity.Types.Boolean,
  },
  maxCount: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      required: false,
    },
  },
  attrubuteCount: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true,
    },
  },
}
const config = {
  load: async function (filter) {
    return (await hillo.get('Category.php', {
      op: 'showAttributeGroup',
      lang: GlobalSettings.getLang(),
      ...filter,
    })).content
  },
  add: async function (item) {
    return (await hillo
      .postWithUploadFile('Category.php?op=addAttributeGroup', item)).content
  },
  edit: function (item) {
    return hillo.postWithUploadFile('Category.php?op=updateAttributeGroup', item, {
      showLoading: true,
    })
  },
  remove: function (id) {
    return hillo.post('Category.php?op=deleteAttributeGroup', { id: id })
  },
  hasDetail: function () {
    return {
      model: () => import('@/model/dish/Attribute'),
      refKey: 'attributeGroupId',
    }
  },
}

export default IKDataEntity.ModelFactory(entity, config)
